module.exports = __webpack_public_path__ + "img/ventilation.94cb558f.svg";